
function initHeroSliders() {
  document.querySelectorAll('[data-hero-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-hero-track]');
    const slides = [...slider.querySelectorAll('[data-hero-slide]')];
    const dots = [...slider.querySelectorAll('[data-hero-dot]')];
    const prev = slider.querySelector('[data-hero-prev]');
    const next = slider.querySelector('[data-hero-next]');
    if (!track || slides.length <= 1) return;

    let index = 0;
    let timer = null;
    const configuredSeconds = Number(slider.dataset.autoplay || 2);
    const intervalMs = Math.max(2000, configuredSeconds * 1000);

    const goTo = (nextIndex, userInitiated = false) => {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      if (userInitiated) restart();
    };

    const stop = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    const start = () => {
      stop();
      timer = window.setInterval(() => goTo(index + 1), intervalMs);
    };

    const restart = () => {
      start();
    };

    prev?.addEventListener('click', () => goTo(index - 1, true));
    next?.addEventListener('click', () => goTo(index + 1, true));
    dots.forEach((dot) => {
      dot.addEventListener('click', () => goTo(Number(dot.dataset.index) || 0, true));
    });

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', (event) => {
      if (!slider.contains(event.relatedTarget)) start();
    });

    goTo(0);
    start();
  });
}

function initQuantityPickers() {
  document.querySelectorAll('[data-qty-picker]').forEach((picker) => {
    const toggle = picker.querySelector('[data-qty-toggle]');
    const menu = picker.querySelector('[data-qty-menu]');
    const input = picker.querySelector('[data-qty-input]');
    if (!toggle || !menu || !input) return;
    toggle.addEventListener('click', () => {
      const open = menu.hidden;
      document.querySelectorAll('[data-qty-menu]').forEach((other) => { other.hidden = true; });
      menu.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
    });
    picker.querySelectorAll('[data-qty-option]').forEach((option) => {
      option.addEventListener('click', () => {
        input.value = option.dataset.value;
        toggle.innerHTML = `Quantity: ${option.dataset.value} <span aria-hidden="true">⌄</span>`;
        menu.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  });
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-qty-picker]')) {
      document.querySelectorAll('[data-qty-menu]').forEach((menu) => { menu.hidden = true; });
      document.querySelectorAll('[data-qty-toggle]').forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));
    }
  });
}

function normalizeProductDescriptionHeadings() {
  // Product descriptions imported from earlier content can contain a second
  // "About this item" heading. Keep the section heading and rename the
  // repeated heading inside the description to "Highlight".
  document.querySelectorAll('[data-product-description]').forEach((description) => {
    description.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach((heading) => {
      if (heading.textContent.trim().toLowerCase() === 'about this item') {
        heading.textContent = 'Highlight';
        heading.classList.add('gg-description-highlight-heading');
      }
    });
  });
}


// V6.0: normalize legacy Shopify resource URLs that may exist in imported theme settings.
// This is a safety net for older settings_data.json values such as shopify://products/... .
function normalizeLegacyShopifyLinks() {
  document.querySelectorAll('a[href]').forEach((anchor) => {
    const href = anchor.getAttribute('href');
    if (!href || !href.startsWith('shopify://')) return;
    const normalized = href
      .replace(/^shopify:\/\/collections\//, '/collections/')
      .replace(/^shopify:\/\/products\//, '/products/')
      .replace(/^shopify:\/\/pages\//, '/pages/')
      .replace(/^shopify:\/\/blogs\//, '/blogs/')
      .replace(/^shopify:\/\/cart\/?/, '/cart')
      .replace(/^shopify:\/\/search\/?/, '/search');
    if (normalized !== href) anchor.setAttribute('href', normalized);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  normalizeLegacyShopifyLinks();
  initHeroSliders();
  initProductGallery();
  initQuantityPickers();
  initProductAvailability();
  initProductRecommendationSliders();
  normalizeProductDescriptionHeadings();

  // Product purchasing: use Shopify's Cart AJAX endpoint for both Add to cart
  // and Buy Now. This avoids the theme-editor navigating to a missing/invalid
  // cart page and lets us show a useful error instead of Shopify's generic error page.
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const addButton = form.querySelector('.gg-amazon-add');
    const buyButton = form.querySelector('[data-buy-now]');
    const errorBox = form.parentElement.querySelector('[data-product-form-error]');

    // Gift products must ALWAYS be added at their real Shopify variant price.
    // Never send a 0 price or attempt to override line-item pricing in theme JS.
    // Shopify's configured automatic/discount rule is responsible for reducing
    // the eligible gift at checkout. This prevents a theme-side $0 line item
    // from conflicting with the Shopify discount.

    const showError = (message) => {
      if (!errorBox) return;
      errorBox.textContent = message || 'Sorry, this item could not be added to your cart. Please try again.';
      errorBox.hidden = false;
    };

    const clearError = () => {
      if (errorBox) errorBox.hidden = true;
    };

    const addCartRequest = async (formData) => {
      // IMPORTANT: FormData contains only the real variant ID + quantity.
      // Do not add price, selling_plan, discount, or 0-value fields here.
      // Shopify remains the source of truth for the variant price/discount.
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData,
        credentials: 'same-origin'
      });
      let data = null;
      try { data = await response.json(); } catch (_) {}
      if (!response.ok) {
        const message = data?.description || data?.message || 'This variant is unavailable. Please choose another option.';
        throw new Error(message);
      }
      return data;
    };

    const addToCart = async () => {
      const baseData = new FormData(form);
      return addCartRequest(baseData);
    };

    // Add to cart: use Shopify Cart AJAX and stay on the current page.
    // IMPORTANT: do not redirect to the product detail page or /cart after adding.
    // This is used by Popular Picks and Activity Products as well as product forms.
    addButton?.addEventListener('click', async (event) => {
      event.preventDefault();
      clearError();
      if (addButton.disabled) return;
      const original = addButton.textContent;
      addButton.disabled = true;
      addButton.textContent = 'Adding…';
      try {
        await addToCart();

        // Refresh the real Shopify cart count so the header reflects the new item.
        try {
          const cartResponse = await fetch('/cart.js', {
            headers: { 'Accept': 'application/json' },
            credentials: 'same-origin'
          });
          const cart = await cartResponse.json();
          document.querySelectorAll('.gg-cart-count').forEach((counter) => {
            counter.textContent = cart.item_count;
            counter.hidden = cart.item_count <= 0;
          });
        } catch (_) {
          // The item was already added successfully; a count refresh failure should
          // never turn a successful Add to Cart action into an error.
        }

        addButton.textContent = 'Added ✓';
        window.setTimeout(() => {
          addButton.disabled = false;
          addButton.textContent = original;
        }, 1200);
      } catch (error) {
        showError(error.message);
        addButton.disabled = false;
        addButton.textContent = original;
      }
    });

    // Buy Now: add the selected variant and go directly to checkout.
    buyButton?.addEventListener('click', async (event) => {
      event.preventDefault();
      clearError();
      if (buyButton.disabled) return;
      const original = buyButton.textContent;
      buyButton.disabled = true;
      if (addButton) addButton.disabled = true;
      buyButton.textContent = 'Adding…';
      try {
        await addToCart();
        window.location.href = '/checkout';
      } catch (error) {
        showError(error.message);
        buyButton.disabled = false;
        if (addButton) addButton.disabled = false;
        buyButton.textContent = original;
      }
    });
  });

  // Newsletter popup: submitting this form subscribes the customer, then shows
  // the success message in-place. The footer newsletter form is intentionally
  // independent and never opens this popup.
  const popup = document.querySelector('[data-newsletter-popup]');
  const popupForm = popup?.querySelector('.gg-newsletter-popup-form');
  const submitFrame = popup?.querySelector('.gg-newsletter-submit-frame');

  const openNewsletterPopup = () => {
    if (!popup) return;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('gg-popup-open');
    localStorage.setItem('ggNewUserPopupSeen', '1');
  };

  const closeNewsletterPopup = () => {
    if (!popup) return;
    popup.classList.remove('is-open', 'is-success');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('gg-popup-open');
  };

  // Add the configured gift at its REAL Shopify variant price.
  // Shopify's automatic discount controls whether the line becomes free at checkout.
  // This function never sends price=0, discount codes, or any client-side price override.
  const addEligibleNewUserGift = async () => {
    if (!popup || popup.dataset.autoGiftEnabled !== 'true') return false;
    const variantId = popup.dataset.autoGiftVariantId;
    if (!variantId) return false;

    // Do not add the gift twice in the same cart.
    try {
      const cartResponse = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      });
      const cart = await cartResponse.json();
      const alreadyInCart = (cart.items || []).some((item) => String(item.variant_id) === String(variantId));
      if (alreadyInCart) return true;
    } catch (error) {
      console.warn('Could not check cart before adding the new-user gift:', error);
    }

    try {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData,
        credentials: 'same-origin'
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data?.description || data?.message || 'Gift could not be added.');

      // Refresh the real Shopify cart count.
      try {
        const refreshed = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' });
        const cart = await refreshed.json();
        document.querySelectorAll('.gg-cart-count').forEach((counter) => {
          counter.textContent = cart.item_count;
          counter.hidden = cart.item_count <= 0;
        });
      } catch (_) {}

      return true;
    } catch (error) {
      console.warn('New-user/new-subscriber gift could not be added:', error);
      return false;
    }
  };

  const showNewsletterSuccess = async () => {
    if (!popup) return;
    const signupState = popup.querySelector('[data-newsletter-signup-state]');
    const successState = popup.querySelector('[data-newsletter-success-state]');
    const successLink = popup.querySelector('[data-newsletter-success-link]');
    if (!signupState || !successState) return;

    // A successful popup subscription qualifies the visitor for the configured gift.
    await addEligibleNewUserGift();
    localStorage.setItem('ggNewUserGiftQualified', '1');

    openNewsletterPopup();
    signupState.hidden = true;
    successState.hidden = false;
    popup.classList.add('is-success');
    if (successLink) successLink.href = popup.dataset.cartUrl || '/cart';
  };

  popup?.querySelectorAll('[data-popup-close]').forEach((el) => {
    el.addEventListener('click', closeNewsletterPopup);
  });

  if (popupForm) {
    // Use a hidden iframe for the native Shopify customer form submission.
    // This avoids Shopify's /contact redirect replacing the page, which was the
    // reason the previous version could submit but never display the success UI.
    if (submitFrame) popupForm.target = submitFrame.name;

    popupForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      const emailInput = popupForm.querySelector('input[type="email"]');
      const submitButton = popupForm.querySelector('button[type="submit"]');
      const email = emailInput?.value?.trim() || '';
      if (!email) return;

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'SUBSCRIBING…';
      }
      if (emailInput) emailInput.disabled = true;

      let submitted = false;
      const markSubmitted = () => { submitted = true; };
      submitFrame?.addEventListener('load', markSubmitted, { once: true });

      try {
        // Trigger the actual Shopify customer form submission into the hidden iframe.
        // It is the real form submission, so the email is saved by Shopify.
        const nativeSubmit = HTMLFormElement.prototype.submit;
        nativeSubmit.call(popupForm);

        // Shopify's customer form redirects inside the iframe. Give it a moment,
        // then continue to the success UI. This is intentionally independent of the
        // footer newsletter form.
        await new Promise(resolve => setTimeout(resolve, 900));
        localStorage.setItem('ggNewsletterSubscribed', '1');
        await showNewsletterSuccess();
      } catch (error) {
        console.warn('Newsletter signup failed:', error);
        if (emailInput) emailInput.disabled = false;
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = 'GET IT NOW';
        }
      }
    });
  }


  // If Shopify knows this is a logged-in first-time customer, automatically add the gift.
  // Anonymous visitors qualify only after they successfully submit the popup newsletter form.
  if (popup && popup.dataset.customerNewUser === 'true' && localStorage.getItem('ggNewUserGiftAdded') !== '1') {
    addEligibleNewUserGift().then((added) => {
      if (added) localStorage.setItem('ggNewUserGiftAdded', '1');
    });
  }

  // Show the initial signup popup only once per browser, including across page changes and tabs.
  if (popup && localStorage.getItem('ggNewUserPopupSeen') !== '1' && localStorage.getItem('ggNewsletterSubscribed') !== '1') {
    let opened = false;
    const openInitialPopup = () => {
      if (opened || popup.classList.contains('is-success')) return;
      opened = true;
      openNewsletterPopup();
      popup.querySelector('input[type="email"]')?.focus();
    };
    setTimeout(openInitialPopup, 5000);
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && window.scrollY / max >= 0.6667) openInitialPopup();
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Mobile navigation drawer.
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const closeMobileMenu = () => {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    mobileMenuToggle?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('gg-mobile-menu-open');
  };
  const openMobileMenu = () => {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    mobileMenuToggle?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('gg-mobile-menu-open');
  };
  mobileMenuToggle?.addEventListener('click', () => {
    if (mobileMenu?.classList.contains('is-open')) closeMobileMenu();
    else openMobileMenu();
  });
  mobileMenu?.querySelectorAll('[data-mobile-menu-close]').forEach((el) => el.addEventListener('click', closeMobileMenu));
  mobileMenu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMobileMenu));


});

// V8: rotate the two announcement messages inside one pink bar.
function initAnnouncementRotator() {
  document.querySelectorAll('[data-announcement-rotator]').forEach((bar) => {
    const messages = [...bar.querySelectorAll('[data-announcement-message]')];
    if (messages.length < 2) return;
    let index = 0;
    const seconds = Math.max(2, Number(bar.dataset.rotationSeconds || 4));
    setInterval(() => {
      messages[index].classList.remove('is-active');
      index = (index + 1) % messages.length;
      messages[index].classList.add('is-active');
    }, seconds * 1000);
  });
}

// Ensure the announcement setting can control rotation speed.
document.addEventListener('DOMContentLoaded', initAnnouncementRotator);
